import StaticSitemapEntriesFA from './fa/fa.json'

const StaticSitemapEntriesMessages = {
  fa: { ...StaticSitemapEntriesFA },
}

export default StaticSitemapEntriesMessages
